import images from "@/assets/images";

interface IMoreProductsComponentProps {}
const MoreProductsComponent: React.FC<IMoreProductsComponentProps> = () => {
  return (
    <div className="hide-scroll-bar mx-auto flex max-h-full flex-col items-center overflow-y-auto pb-[30px] pt-[10px]">
      <div className="mb-[10px] w-[358px] rounded-[12px] bg-[#FFFFFF0F] p-[20px]">
        <img src={images.App41} className="mb-[20px] w-full" />
        <p className="mb-[4px] text-[24px] leading-[42px] text-[#0EF69C]">
          虎牙直播 x 三角州地图工具
        </p>
        <p className="text-[16px] leading-[22px] text-[#fff]">0成本熟图、摸金模拟、路线规划</p>
      </div>
      <div className="mb-[10px] w-[358px] rounded-[12px] bg-[#FFFFFF0F] p-[20px]">
        <img src={images.App42} className="mb-[20px] w-full" />
        <p className="mb-[4px] text-[24px] leading-[42px] text-[#fff]">奶瓶加速器</p>
        <p className="text-[16px] leading-[22px] text-[#fff]">
          专业电竞级 Steam 游戏加速器，高速专网
        </p>
      </div>
      <div className="mb-[20px] w-[358px] rounded-[12px] bg-[#FFFFFF0F] p-[32px]">
        <p className="mb-[8px] text-[32px] leading-[45px] text-[#fff]">PC极速版客户端</p>
        <p className="whitespace-break-spaces text-[16px] leading-[22px] text-[#fff]">
          {"基于全新微软.NET Core内核\n更快，更稳定，更兼容"}
        </p>
      </div>
      <p className="mb-[4px] text-[14px] leading-[20px] text-[#FFFFFF99]">请在电脑访问操作</p>
      <p className="text-[14px] leading-[22px] text-[#FFFFFF99]">https://hd.huya.com/download/</p>
    </div>
  );
};

export default MoreProductsComponent;
